import { useContext, useMemo, useRef } from 'react'

import { appConfig } from '@/config'

import { AuthContext } from 'torqcloud-ui'
import { useOrganization } from '@/contexts/OrganizationContext'
import { PublicApi, RequestParams } from '@api/generated/public/publicApi'

const BASE_URL = `${appConfig.flowiseBaseUrl}/api/v2/public`

export default function usePublicApi() {
  const context = useContext(AuthContext)
  const { currentOrganizationId } = useOrganization()
  const orgId = useRef(currentOrganizationId)
  orgId.current = currentOrganizationId

  return useMemo(() => {
    return new PublicApi<void>({
      baseUrl: BASE_URL,
      baseApiParams: {
        secure: true,
      },
      securityWorker: async (): Promise<RequestParams> => {
        const session = await context.authenticationManager.currentSession()
        const token = session?.getIdToken()?.getJwtToken()
        const headers: Record<string, string> = {}

        if (token) {
          headers.Authorization = `Bearer ${token}`
        }

        if (orgId.current) {
          headers['x-organizationId'] = orgId.current
        }

        return { headers }
      },
    })
  }, [context.authenticationManager])
}
